import { SATISFACTION_RESPONSE_ENDPOINT } from './constants';
import {
  SatisfactionResponse,
  SatisfactionForm,
  SatisfactionCallbackResponse,
  UpdateSatisfactionResponseOptions,
} from './types';

export const validateUpdateSatisfactionResponseParams = (
  satisfactionResponseId,
  parameters: UpdateSatisfactionResponseOptions,
) => {
  if (!satisfactionResponseId) {
    return new Error('A satisfactionId must be provided.');
  }

  const { rating, answers } = parameters;

  const answer = answers?.[0]?.answer;

  if (answer && answer.length > 1024) {
    return new Error(
      'Property followupAnswer must be less than or equal to 1024 characters',
    );
  }

  if (rating && (typeof rating !== 'number' || rating > 10 || rating < 1)) {
    return new Error('Rating must be a number between 1 and 10');
  }

  return undefined;
};

export const createSatisfactionCallbackResponse = (
  response: SatisfactionResponse,
  pubNubTimetoken?: string | number,
  form?: SatisfactionForm,
): SatisfactionCallbackResponse => {
  const callbackResponse = {} as SatisfactionCallbackResponse;

  const conversationId = response?.relationships?.conversation?.data?.id;
  const sessionId = response?.relationships?.session?.data?.id;

  if (!response || !form || (!conversationId && !sessionId))
    return callbackResponse;

  const { id } = response;
  const { rating, answers, createdAt } = response?.attributes;

  const followupAnswer = answers?.[0]?.answer;

  callbackResponse.conversationId = conversationId || sessionId;
  callbackResponse.satisfactionId = id;

  let timetoken = createdAt;

  if (pubNubTimetoken) {
    const convertedToken = Number(pubNubTimetoken) / 10000;
    timetoken = new Date(convertedToken).toISOString();
  }

  callbackResponse.timetoken = timetoken;

  callbackResponse.response = {
    rating,
    followupAnswer,
  };

  if (form) {
    const {
      description,
      introduction,
      name,
      questions,
      ratingPrompt,
      scale,
    } = form?.attributes;

    const followupQuestion = questions?.[0]?.prompt;

    callbackResponse.form = {
      description,
      introduction,
      name,
      followupQuestion,
      ratingPrompt,
      scale,
    };
  }

  return callbackResponse;
};

export const makeSatisfactionResponseEndpoint = (id: string) => {
  return `/c/v2/chat/satisfaction-responses/${id}?include=satisfaction` as typeof SATISFACTION_RESPONSE_ENDPOINT;
};
